import { isMobile } from '@utils/mobile';
import { useEffect, useState } from 'react';

const media = window.matchMedia('(prefers-color-scheme: dark)');

const icons = [
  ...document.querySelectorAll('link[rel="icon"]'),
  document.querySelector('link[rel="apple-touch-icon"]'),
];

export const useFavicon = () => {
  const [dark, setDark] = useState(isMobile() ? false : media.matches);

  const updateTheme = (e: MediaQueryListEvent) => setDark(e.matches);

  useEffect(() => {
    media.addEventListener('change', updateTheme);
    return () => media.removeEventListener('change', updateTheme);
  }, []);

  useEffect(() => {
    icons.forEach((el) => {
      if (!el) return;
      const link = el as HTMLLinkElement;
      // eslint-disable-next-line immutable/no-mutation
      link.href = [
        link.href.replace('.png', '').replace('-dark', ''),
        dark ? '-dark.png' : '.png',
      ].join('');
    });
  }, [dark]);
};
